import { Label } from 'reactstrap';
import styled from 'styled-components';

export const LabelOrcamento = styled(Label)`
  color: #8898aa;
  font-size: 1.4rem;
  font-weight: 600;
`;
